export default __webpack_public_path__ + "static/media/prana05.d5f3d78c.JPG";